module.exports = __webpack_public_path__ + "assets/63404fc8a38e91b2eb1f6d8da2e6cf9e.png";